// @flow

import { ModalButton } from "../../../components/ModalButton";
import { Spacer } from "../../../components/common/Spacer";
import {
	type Theme,
	getColor,
	getSize,
	getWeight,
} from "views/resources/theme";
import { Wait, Waiting } from "../icons";
import React from "react";
import styled, { type StyledComponent } from "styled-components";
import type { Line, Ticket } from "types";

interface Props {
	line: Line;
	ticket: Ticket;
	officeName: string;
	dowloadTicketAction: () => void;
	type: string;
}

const TicketCard = ({
	line,
	ticket,
	officeName,
	date,
	dowloadTicketAction,
	type,
}: Props) => (
	<Wrapper>
		{/* <TopView>
			<Waiting waiting={line.waiting} />
			<Wait wait={line.wait} />
		</TopView> */}
		<BotView>
			<div>
				<span>Número de ticket:</span>
				<h1>
					{ticket.prefix}
					{ticket.number}
				</h1>
			</div>
			<div>
				<span>Nombre de fila:</span>
				<h2>{line.name}</h2>
			</div>
			<br></br>
			<div className="status">En espera de atención</div>
			<br></br>
			<div className="timestamp">
				<span>Fecha de emisión: </span>
				<h2>{date}</h2>
			</div>
			<Spacer rows={2} />
			<div className="button__ticket-screen">
				<ModalButton
					onClick={() =>
						dowloadTicketAction(
							line,
							ticket,
							date,
							type,
							officeName
						)
					}
					loading={false}
					type={"primary"}
					label="Descargar Ticket"
				/>
			</div>
		</BotView>
	</Wrapper>
);

const TopView = styled.div`
	display: flex;
	height: 76px;
	border-bottom: 2px dashed #a1a1a1;
	margin: 0;
	position: relative;
	border-bottom: 2px dashed #a1a1a1;
	padding-top: 10px;
	justify-content: space-evenly;
`;

const BotView = styled.div`
	padding: 19px 0 21px;
	text-align: center;
	margin: 0;
	h1 {
		color: ${getColor("primary")};
		margin: 0;
		color: #145ab4;
		font-family: Roboto;
		font-size: 43px;
		font-weight: 900;
	}

	h2 {
		color: ${getColor("primary")};
		font-size: 16px;
		margin: 0;
	}

	span {
		font-weight: ${getWeight("medium")};
		color: ${getColor("fg")};
	}
	.button__ticket-screen {
		width: 100%;
		& button {
			width: 80%;
			margin: 0 auto;
		}
	}
`;

const Wrapper: StyledComponent<*, Theme, *> = styled.div`
	mask: radial-gradient(
			circle at left 86px,
			transparent,
			transparent 20px,
			white 22px,
			white 80%,
			transparent 80%,
			transparent
		),
		radial-gradient(
			circle at right 86px,
			transparent,
			transparent 20px,
			white 22px,
			white 80%,
			transparent 80%,
			transparent
		);

	mask-size: 100% 100%;
	border-radius: ${getSize("s")};
	background-color: ${getColor("bg")};
	margin: 0;
	position: relative;
	overflow: hidden;

	.status {
		color: ${getColor("primary_light")};
	}

	.timestamp {
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		align-content: center;
	}
`;

export default TicketCard;
